export const CacheExpiryForARIApi = 5; // In Minutes
